import { useMemo } from "react"

import { CoachingSubscriptionInfo } from "../../../types"

const useSubscriptionTypes = (
  coachingSubscriptions: {
    coachId: number | undefined
    clientId: number | undefined
    result: CoachingSubscriptionInfo
  }[]
) => {
  const { numVideoSubs, numChatSubs } = useMemo(() => {
    let numVideoSubs = 0
    let numChatSubs = 0
    coachingSubscriptions?.forEach((subscription) => {
      if (subscription.result.num_sessions > 0) {
        numVideoSubs += 1
      } else if (subscription.result.num_sessions === 0) {
        numChatSubs += 1
      }
    })
    return { numVideoSubs, numChatSubs }
  }, [coachingSubscriptions])

  return { numVideoSubs, numChatSubs }
}

export default useSubscriptionTypes
